import asBentoPage from 'common/bento/hoc/asBentoPage';
import Button from 'components/_core/Button';
import Callout from 'components/_core/Callout';
import OBNavigation from 'features/Onboarding/components/OBNavigation/OBNavigation';

import Header from '../../../../components/Header';
import locales from './locales';

interface IntroProps {
  firstName: string | null;
  onNext: () => void;
  isMandatee: boolean;
}

const getDescription = ({
  firstName,
  isMandatee,
}: {
  isMandatee: boolean;
  firstName: string | null;
}): string => {
  if (isMandatee) {
    return locales.description.mandatee;
  }

  return firstName
    ? (locales.formatString(locales.description.nonMandatee.withFirstname, {
        firstName,
      }) as string)
    : locales.description.nonMandatee.withoutFirstname;
};

const CapitalDepositQuestionsIntro = asBentoPage<IntroProps>(
  ({ firstName, isMandatee, Layout, onNext, onPrev }) => (
    <Layout nav={<OBNavigation onPrev={onPrev} />}>
      <Header
        description={getDescription({ firstName, isMandatee })}
        title={isMandatee ? locales.title.mandatee : locales.title.nonMandatee}
      />

      <Callout marginBottom="space-40">
        <Callout.Content>
          {isMandatee ? locales.warning.mandatee : locales.warning.nonMandatee}
        </Callout.Content>
      </Callout>

      <Button isExpanded onClick={onNext}>
        {locales.ctaButton}
      </Button>
    </Layout>
  ),
);

export default CapitalDepositQuestionsIntro;
